module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/banner-cc225fea242471a574830ed0226607cb.gif";